<template>
  <div :class="['cm-tabs', `cm-tabs--${type}`, { 'cm-tabs--scroll': scroll }]">
    <div class="cm-tabs-header">
      <span
        v-for="(item, index) in tabs"
        :key="index"
        :class="[
          'cm-tabs-header__item',
          { 'cm-tabs-header__item--active': activeTab === index },
          { 'cm-tabs-header__item--locked': item.isLocked }
        ]"
        @click="activeTab = index"
      >
        {{ item.label || item }}
      </span>
      <span class="cm-tabs-header__item--last"></span>
      <!-- for static content inside header for all tabs -->
      <slot name="cm-tabs-header-inside"></slot>
    </div>
    <slot name="cm-tabs-between-content"></slot>
    <div v-if="tabs[activeTab]" class="cm-tabs-container" :class="containerClass">
      <!-- for static content inside container for all tabs -->
      <slot name="cm-tabs-container-inside"></slot>
      <slot :name="tabs[activeTab].id || tabs[activeTab].label || tabs[activeTab]"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CmTabs",

  props: {
    value: {},
    type: {
      default: 1
    },
    tabs: {
      type: Array,
      required: true
    },
    scroll: {
      type: Boolean,
      default: false
    },
    containerClass: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      activeTab: 0
    }
  },

  mounted() {
    if (this.value) this.activeTab = this.value;
  },

  watch: {
    activeTab(next) {
      if (this.value || this.value === 0) {
        this.$emit("input", next);
      }
    }
  }
}

// Component description
// 1. if we want to know active tab or change default activeTab
//    use v-model
// 2. For inserting some static blocks for all tabs use:
//    - inside header - slot="cm-tabs-header-inside"
//    - inside container - slot="cm-tabs-container-inside"
// 3. Three type of style in props number of type:
//    1 - with underline
//    2 - without lines
//    3 - with above lines

// HOW TO USE:
// <CmTabs tabs=['tab1', 'tab2']>
//    <div :slot="tabs[0]"></div>
//    <div :slot="tabs[1]"></div>
// </CmTabs>
</script>

<style lang="scss">
.cm-tabs {
  display: flex;
  flex-direction: column;
  height: 100%;
  &-header {
    font-size: 16px;
    display: flex;
    white-space: nowrap;

    &__item {
      text-transform: uppercase;
      transition: all 0.3s ease;
      cursor: pointer;

      &--active {
        pointer-events: none;
      }

       &--locked {
        position: relative;
        cursor: not-allowed !important;
        pointer-events: none;

        &:after {
          background: url("#{$image-path}icon_locked.svg") no-repeat center center;
          position: absolute;
          content: "";
          width: 24px;
          height: 100%;
          bottom: 2px;
          right: 0;
        }
      }
    }
  }

  &-container {
    flex-grow: 1;
    // overflow-x: auto;
    .cm-tabs-container {
      overflow: hidden;
    }
  }

  &--scroll {
    & > .cm-tabs-container {
      overflow-y: auto;
    }
  }

  // types
  &--1 {
    & > .cm-tabs-header {
      border-bottom: 1px solid $color_gray_new;
      width: 100%;
      padding: 0 $regular-space;
      margin-bottom: -1px;
      .cm-tabs-header__item {
        border-bottom: 4px solid transparent;
        padding: 12px 0;

        &:not(:last-child) {
          margin-right: 25px;
        }

        &:hover {
          color: $color_salat;
        }

        &--active {
          border-bottom: 4px solid $color_salat;
        }

        &--locked:after {
          bottom: 0px;
          right: -25px;
        }
      }
    }
  }

   &--2 {
    & > .cm-tabs-header {
      padding: 0 $regular-space;
      .cm-tabs-header__item {
        color: $color_gray_b1;
        padding: 10px;
        &:not(:first-child) {
          position: relative;
          &:after {
            background: $color_gray_lighter;
            content: "";
            width: 1px;
            height: 18px;
            position: absolute;
            top: 12px;
            left: 0;
          }
        }

        &:first-child {
          padding-left: 0;
        }

        &:hover {
          opacity: 0.8;
        }

        &--active {
          color: $color_green_new;
        }
      }
    }
  }

  &--3 {
    & > .cm-tabs-header {
      border-top: 1px solid $color_gray_new;
      width: 100%;
      margin-top: -1px;
      .cm-tabs-header__item {
        border-top: 4px solid transparent;
        border-bottom: 1px solid $color_border;
        padding: 10px 20px 14px;

        &:hover {
          color: $color_green-new;
        }

        &--active {
          border-top: 4px solid $color_green-new;
          border-bottom: 1px solid transparent;
          position: relative;
          &:before {
            background: $color_border;
            content: "";
            width: 1px;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
          &:after {
            background: $color_border;
            content: "";
            width: 1px;
            height: 100%;
            position: absolute;
            top: 0;
            right: 0;
          }
        }

        &--last {
          border-bottom: 1px solid $color_border;
          flex-basis: 100%;
        }

        &:first-child:before {
          background: transparent;
        }
      }
    }
  }
}
</style>
